import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'FadeTransition'
},
  __name: 'FadeTransition',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition duration-100 ease-out",
    "enter-from-class": "scale-95 opacity-0",
    "enter-to-class": "scale-100 opacity-100",
    "leave-active-class": "transition duration-75 ease-in",
    "leave-from-class": "scale-100 opacity-100",
    "leave-to-class": "scale-95 opacity-0"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})